import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { empty } from 'ramda';

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, filter, finalize, first, skip, switchMap, take, takeUntil } from 'rxjs/operators';

import { TokenLog } from '../entities/token-log.model';
import { AuthService } from '../services/auth.service';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  private refreshTokenInProgress = false;
  private readonly refreshToken$ = new BehaviorSubject<any>(null);
  private readonly refreshTokenFail$ = new Subject<void>();

  constructor(private readonly authService: AuthService, private readonly router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


   
    return next.handle(req).pipe(
      catchError((error) => {
        
        if(isUserRegisterRequest(req) || isLoginTokenRequest(req)){
          return next.handle(req);
        }
        

        // handle logout
        console.log("RefreshTokenInterceptor>>>");
        if (req.urlWithParams.includes('api/users?=logout')) {
          throw new Error('Function not implemented.');
        }

        // handle the login and refresh_token requests
        if (req.url.includes('oauth/token')) {
          if (isRefreshTokenRequest(req)) {
            this.authService.addRedirectUrl(location.pathname + location.search);
            this.authService.logout();
          }
          throw new Error('Function not implemented.');
        }

        // handle the error except the unauthorized request
        if (error.status == 401) {

        if (this.refreshTokenInProgress) {
          // hold on the subsequent requests until we get the new token
          return this.refreshToken$.pipe(
            filter((result) => result !== null),
            take(1),
            switchMap(() => this.updateAuthorization(next, req)),
            takeUntil(this.refreshTokenFail$),
          );
        } else {
          this.refreshTokenInProgress = true;

          this.refreshToken$.next(null);

          this.authService.refreshToken$().subscribe();

          return this.authService.userInfo$.pipe(
            skip(1),
            first(),
            switchMap((tokenLog: TokenLog) => {
              if (tokenLog.access_token) {
                this.refreshToken$.next(tokenLog);
                return this.updateAuthorization(next, req);
              } else {
                this.refreshTokenFail$.next();
                this.router.navigate(['/login']);
                throw new Error('Function not implemented.');
              }
            }),
            finalize(() => (this.refreshTokenInProgress = false)),
          );
        }
      }
    }),
    );
  }

  

  private updateAuthorization(next: HttpHandler, req: HttpRequest<any>): Observable<HttpEvent<any>> {
    return this.authService.userInfo$.pipe(
      first(),
      switchMap((userInfo) => {
        if (userInfo.access_token) {
          // Clone the request and set the new header in one step.
          const authReq = req.clone({
            setHeaders: {
              Authorization: `${userInfo.token_type} ${userInfo.access_token}`,
            },
          });

          // send cloned request with header to the next handler.
          return next.handle(authReq);
        } else {
          return next.handle(req);
        }
      }),
    );
  }
}

function isRefreshTokenRequest(req: HttpRequest<any>): boolean {
  return typeof req.body === 'string' && req.url.includes('grant_type=refresh_token');
}
function isUserRegisterRequest(req: HttpRequest<any>) {
  return typeof req.body === 'object' && req.url.includes('/users/register');
}
function isLoginTokenRequest(req: HttpRequest<any>): boolean {
  return typeof req.body === 'string' && req.url.includes('grant_type=password');
}
 
